





































































import {
	computed,
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { v4 } from 'uuid';
import { focus } from '@front-app/directives/focus';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { FOCUSABLE_ERROR_INPUT_CLASS } from '@front-app/components/form/form';

// These keys are handled by the selection items themselves. All
// other key events are passed up to the wrapper to allow the user
// to start typing while a selection item has been focused
const SELECTION_ITEM_IGNORED_KEYS = [
	'Meta',
	'ArrowUp',
	'ArrowDown',
	'ArrowLeft',
	'ArrowRight',
	'Enter',
];

export default defineComponent({
	directives: {
		focus,
	},
	components: {
		FontAwesomeIcon,
	},
	props: {
		value: {
			type: String,
			required: true,
			default: '',
		},
		placeholder: {
			type: String,
			default: 'search.searchPlaceholder',
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_LEFT,
		},
		fieldId: {
			type: String,
			required: false,
			default: null,
		},
		hasError: Boolean,
		focus: Boolean,
		onDark: Boolean,
		noDropdown: Boolean,
		matchWidth: Boolean,
		showDropdownWithEmptyValue: Boolean,
		withLeftDropdown: Boolean,
	},
	setup(props, ctx) {
		const innerId = `search_${v4()}`;
		const id = computed(() => props.fieldId ?? innerId);

		const focusInput = ref(false);
		const computedFocus = computed(() => props.focus || focusInput.value);
		const containerEl = ref(null as null | Element);
		const hasFocusWithin = ref(false);
		const showDropdown = computed(() => (props.value !== '' || props.showDropdownWithEmptyValue) && hasFocusWithin.value && !props.noDropdown);
		watch(showDropdown, (curr: boolean) => {
			if (!curr) {
				ctx.emit('dropdown-hidden');
			} else {
				ctx.emit('dropdown-shown');
			}
		});
		const onBlur = (e: FocusEvent) => {
			if ((e.target as HTMLElement).id === id.value) {
				ctx.emit('blur-input');
			}
			// Without the setTimeout, the blur event completes before the the "click" event,
			// removing the actual click target from the DOM, and breaking the links
			setTimeout(() => {
				const el = containerEl.value;
				if (!el) {
					hasFocusWithin.value = false;
					return;
				}
				hasFocusWithin.value = el.querySelectorAll(':focus').length > 0;
				focusInput.value = false;
			}, 150);
		};

		const onButtonKeydown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				e.stopPropagation();
				e.preventDefault();
			}

			if (!SELECTION_ITEM_IGNORED_KEYS.includes(e.key)) {
				focusInput.value = true;
			}
		};

		return {
			id,
			DropdownPosition,
			containerEl,
			showDropdown,
			focusInput,
			computedFocus,
			onBlur,
			onButtonKeydown,
			FOCUSABLE_ERROR_INPUT_CLASS,
			onFocus: () => {
				hasFocusWithin.value = true;
				ctx.emit('focus');
			},
			onEscape: () => {
				ctx.emit('input', '');
				focusInput.value = hasFocusWithin.value;
			},
		};
	},
});
